const tabs = {listtab: 'tablist', registertab: 'tabregister'};

export const profileTabs = {
    tabs,
};
